// [sc-49272] Click su un documento (PDF di preventivo o DDT) → apertura con la
// sessione, al posto del link diretto all'API. Condiviso da Preventivi,
// creazione e modifica del preventivo.

import { openDocument } from "@/utilities/openDocument";

export default {
  methods: {
    // objectName c'è per i DDT (ricavato da documentUrl), per i preventivi è il name
    async openDoc(doc) {
      try {
        await openDocument(doc.objectName ?? doc.name);
      } catch (err) {
        console.error("Errore nell'apertura del documento:", err);
        this.$toast.error("Impossibile aprire il documento");
      }
    },
  },
};
